export const BASE_API_URL = "https://stage-hostservice.whimstay.com/v1"

export const WHIMSTAY_WEB_URL = "https://uat.whimstay.com"

export const hubspot = "hubspot"

export const SAMANTHA_MEETING_LINK =
  "https://meetings.hubspot.com/samantha-vazquez1/onboarding-call"
export const SHAYLA_MEETING_LINK =
  "https://meetings.hubspot.com/shayla-hicks/onboarding-call-"

export const VACASA_PMCID = "4915961"
export const INTERHOME_PMCID = "IH000002"
